export const JobsAndScoresService = {
  getData() {
    return [
      {
        jobsName: 'Работа 1',
        measure: 'Часы',
        value: '1',
        id: '875fd4eb-196e-41d7-a058-11826a7ecb23'
      },
      {
        jobsName: 'Работа 2',
        measure: 'Минуты',
        value: '2',
        id: '21e1a9e8-483d-4979-a4ca-91ec3a65ffc5'
      },
      {
        jobsName: 'Работа 3',
        measure: 'Оценка',
        value: '3',
        id: '6f8ce149-068a-451c-b8fe-d83db65e401f'
      },
      {
        jobsName: 'Работа 4',
        measure: 'балл',
        value: '4',
        id: 'ba407612-3ac8-4bfc-8c29-606e54453aed'
      },
      {
        jobsName: 'Работа 5',
        measure: 'Часы',
        value: '5',
        id: '8e226f4a-52f7-4125-a768-8c672e6aac4c'
      },
      {
        jobsName: 'Работа 6',
        measure: 'Минуты',
        value: '6',
        id: 'acaeb96d-7df5-4e21-8653-90ba4f6ae1f3'
      },
      {
        jobsName: 'Работа 7',
        measure: 'Оценка',
        value: '7',
        id: '66952058-5e52-43f9-9478-5e1335751946'
      },
      {
        jobsName: 'Работа 8',
        measure: 'балл',
        value: '8',
        id: 'f97b45c5-e13c-4027-a080-5aab962462ba'
      },
      {
        jobsName: 'Работа 9',
        measure: 'Часы',
        value: '9',
        id: 'a311396a-0f09-4f90-9314-65d52157b2c7'
      },
      {
        jobsName: 'Работа 10',
        measure: 'Минуты',
        value: '10',
        id: '864cdbc4-9c97-404e-92e0-19ad7d0c1831'
      },
      {
        jobsName: 'Работа 11',
        measure: 'Оценка',
        value: '11',
        id: 'cd0ed0d7-641e-47aa-91e1-0479e0765ddc'
      },
      {
        jobsName: 'Работа 12',
        measure: 'балл',
        value: '12',
        id: '54aaf87e-9c01-49eb-98cf-e0f8a451208a'
      },
      {
        jobsName: 'Работа 13',
        measure: 'Часы',
        value: '13',
        id: '8a96b9f7-36fd-40c2-b9cf-330da9b3b232'
      },
      {
        jobsName: 'Работа 14',
        measure: 'Минуты',
        value: '14',
        id: '44e8fce3-7994-49af-935c-9074904c2c01'
      },
      {
        jobsName: 'Работа 15',
        measure: 'Оценка',
        value: '15',
        id: '20cf3115-f25d-4f16-81d5-1116c94e79d3'
      },
      {
        jobsName: 'Работа 16',
        measure: 'балл',
        value: '16',
        id: '0813b438-634a-4e34-842a-bbae191870be'
      },
      {
        jobsName: 'Работа 17',
        measure: 'Часы',
        value: '17',
        id: '3da93f28-e968-4021-a085-6e2a0007b842'
      },
      {
        jobsName: 'Работа 18',
        measure: 'Минуты',
        value: '18',
        id: '8a612533-84cf-4e1e-b5fb-224c3fafdf34'
      },
      {
        jobsName: 'Работа 19',
        measure: 'Оценка',
        value: '19',
        id: 'af90c0b8-52d4-4dff-8a4c-f93c1e3ff8ef'
      },
      {
        jobsName: 'Работа 20',
        measure: 'балл',
        value: '20',
        id: '70ac87be-f18e-4ad3-b2c3-aa2da01bb893'
      },
      {
        jobsName: 'Работа 21',
        measure: 'Часы',
        value: '21',
        id: 'f160a017-83e2-4876-bc36-1ff1c501755e'
      },
      {
        jobsName: 'Работа 22',
        measure: 'Минуты',
        value: '22',
        id: '6f934610-599d-4f0d-89b3-f9ad962e3551'
      },
      {
        jobsName: 'Работа 23',
        measure: 'Оценка',
        value: '23',
        id: 'ca59be44-8473-4bd2-a696-34cc728e38d4'
      },
      {
        jobsName: 'Работа 24',
        measure: 'балл',
        value: '24',
        id: '6ea0f8a5-97d2-47a5-8880-db11186f6963'
      },
      {
        jobsName: 'Работа 25',
        measure: 'Часы',
        value: '25',
        id: 'e3f9f421-8f4e-4572-adbf-105a837fe93f'
      },
      {
        jobsName: 'Работа 26',
        measure: 'Минуты',
        value: '26',
        id: '9444de7e-a634-4b02-a2b5-5db827c7b6ac'
      },
      {
        jobsName: 'Работа 27',
        measure: 'Оценка',
        value: '27',
        id: 'd4894c3e-f22c-4134-a15e-4f35b04d5436'
      },
      {
        jobsName: 'Работа 28',
        measure: 'балл',
        value: '28',
        id: '059282f8-bca5-4efb-ac1c-da4896867beb'
      },
      {
        jobsName: 'Работа 29',
        measure: 'Часы',
        value: '29',
        id: '9d5aa0bb-0c91-42f8-b5f3-7db5c4b75468'
      },
      {
        jobsName: 'Работа 30',
        measure: 'Минуты',
        value: '30',
        id: '853aab60-182a-4115-9450-6cd07f8ef402'
      },
      {
        jobsName: 'Работа 31',
        measure: 'Оценка',
        value: '31',
        id: 'b931b206-99d3-436c-b5a1-2ed56c824900'
      },
      {
        jobsName: 'Работа 32',
        measure: 'балл',
        value: '32',
        id: '129ed86e-66d9-4bd2-a4e2-9a38029d299e'
      },
      {
        jobsName: 'Работа 33',
        measure: 'Часы',
        value: '33',
        id: '43be5f07-82a0-494c-9773-887a6b92e80d'
      },
      {
        jobsName: 'Работа 34',
        measure: 'Минуты',
        value: '34',
        id: 'e8c73e8f-9667-4646-9523-0b820c8b72f1'
      },
      {
        jobsName: 'Работа 35',
        measure: 'Оценка',
        value: '35',
        id: '7fcd4d4b-cbc8-43be-9410-704b695076bf'
      },
      {
        jobsName: 'Работа 36',
        measure: 'балл',
        value: '36',
        id: 'b5e90ca2-229e-42b2-a4d7-e9f8ca77ce7d'
      },
      {
        jobsName: 'Работа 37',
        measure: 'Часы',
        value: '37',
        id: 'fe28da0e-3b7b-48c0-a690-a0b888fdfba4'
      },
      {
        jobsName: 'Работа 38',
        measure: 'Минуты',
        value: '38',
        id: 'a820a0e6-37a3-4f5f-8a25-936c432bb7dc'
      },
      {
        jobsName: 'Работа 39',
        measure: 'Оценка',
        value: '39',
        id: '6544a485-e241-45a3-9cae-b695767712d6'
      },
      {
        jobsName: 'Работа 40',
        measure: 'балл',
        value: '40',
        id: '09f6245b-6c35-4498-b8db-9b3b277c8c88'
      },
      {
        jobsName: 'Работа 41',
        measure: 'Часы',
        value: '41',
        id: '60bb4235-4894-4405-9879-de35a2cafe71'
      },
      {
        jobsName: 'Работа 42',
        measure: 'Минуты',
        value: '42',
        id: 'ae78c192-946e-4f76-b94d-d6ec3af5f763'
      },
      {
        jobsName: 'Работа 43',
        measure: 'Оценка',
        value: '43',
        id: 'd462eb80-eceb-4a3b-8a0e-07ceb967283c'
      },
      {
        jobsName: 'Работа 44',
        measure: 'балл',
        value: '44',
        id: 'a68ccdf1-3624-4998-a67a-5847188d7233'
      },
      {
        jobsName: 'Работа 45',
        measure: 'Часы',
        value: '45',
        id: 'bb86e787-b008-4767-bc2d-e189e1eab021'
      },
      {
        jobsName: 'Работа 46',
        measure: 'Минуты',
        value: '46',
        id: '4adf56a4-20a2-4143-962d-184db36e9352'
      },
      {
        jobsName: 'Работа 47',
        measure: 'Оценка',
        value: '47',
        id: 'cd8a0067-aa8a-4786-9541-7584851b8b95'
      },
      {
        jobsName: 'Работа 48',
        measure: 'балл',
        value: '48',
        id: 'cc6a7607-246a-4468-b0c9-7b8c88bc07cf'
      },
      {
        jobsName: 'Работа 49',
        measure: 'Часы',
        value: '49',
        id: '71f431bf-2714-4d1b-b262-0b3b966232de'
      },
      {
        jobsName: 'Работа 50',
        measure: 'Минуты',
        value: '50',
        id: '5fed11a3-0770-4598-a24c-66ea35edf481'
      },
      {
        jobsName: 'Работа 51',
        measure: 'Оценка',
        value: '51',
        id: '95db4d78-aff7-4287-965c-dfa48ce2bc54'
      },
      {
        jobsName: 'Работа 52',
        measure: 'балл',
        value: '52',
        id: 'e99ae109-cea3-4660-ab88-34b09943fe5b'
      },
      {
        jobsName: 'Работа 53',
        measure: 'Часы',
        value: '53',
        id: '4069d34e-50c8-4a65-aade-2ddc91628d85'
      },
      {
        jobsName: 'Работа 54',
        measure: 'Минуты',
        value: '54',
        id: '09db3fe9-c6e3-49d7-b6f0-5292e94fa552'
      },
      {
        jobsName: 'Работа 55',
        measure: 'Оценка',
        value: '55',
        id: '8410aff1-6694-4fa5-b59b-8bb4a3e2eb0e'
      },
      {
        jobsName: 'Работа 56',
        measure: 'балл',
        value: '56',
        id: '946c831d-d042-4daa-828f-0dbf9786640e'
      },
      {
        jobsName: 'Работа 57',
        measure: 'Часы',
        value: '57',
        id: 'd70a62c5-7ff1-4bf5-a4ec-80ee1bba3846'
      },
      {
        jobsName: 'Работа 58',
        measure: 'Минуты',
        value: '58',
        id: '60533d68-41ca-446d-9773-bf67a4c7dd4d'
      },
      {
        jobsName: 'Работа 59',
        measure: 'Оценка',
        value: '59',
        id: '84a8f3a8-1b67-4970-8a1f-e84f24dffc88'
      },
      {
        jobsName: 'Работа 60',
        measure: 'балл',
        value: '60',
        id: 'b873fd10-531e-42f9-abb5-19a564ce468a'
      },
      {
        jobsName: 'Работа 61',
        measure: 'Часы',
        value: '61',
        id: 'c1ddd161-cb28-4727-9ded-0c50c7acf49b'
      },
      {
        jobsName: 'Работа 62',
        measure: 'Минуты',
        value: '62',
        id: 'f95914f5-7736-49c6-be7b-dffaaac47379'
      },
      {
        jobsName: 'Работа 63',
        measure: 'Оценка',
        value: '63',
        id: '50471682-c6e9-413b-bf1d-cf805594dddf'
      },
      {
        jobsName: 'Работа 64',
        measure: 'балл',
        value: '64',
        id: '7d8fad3e-2577-4925-824f-314efd7123bb'
      },
      {
        jobsName: 'Работа 65',
        measure: 'Часы',
        value: '65',
        id: '756a1032-e3bd-4d66-845d-491cbe0d9449'
      },
      {
        jobsName: 'Работа 66',
        measure: 'Минуты',
        value: '66',
        id: 'ca1bb0d5-de75-49fa-93c1-9c3962b68075'
      },
      {
        jobsName: 'Работа 67',
        measure: 'Оценка',
        value: '67',
        id: 'bcfabb73-3d1b-4c69-b0e6-5fd7a7ec873f'
      },
      {
        jobsName: 'Работа 68',
        measure: 'балл',
        value: '68',
        id: 'b89c704e-4cae-429d-9b4a-ff03fc0516fc'
      },
      {
        jobsName: 'Работа 69',
        measure: 'Часы',
        value: '69',
        id: '9ad4ec87-e5be-46b2-bd98-3b31493c30b6'
      },
      {
        jobsName: 'Работа 70',
        measure: 'Минуты',
        value: '70',
        id: 'ed8a624a-452d-4c9c-a6e5-4ca371cdff07'
      }
    ];
  },

  getJobsAndScores() {
    return Promise.resolve(this.getData());
  }
};
